import { createSelector } from 'reselect';
const selectViewerInsights = state => state.viewerInsights;

export const selectIsActive = createSelector(
  selectViewerInsights,
  viewerInsights => viewerInsights.isActive
);
export const selectViewers = createSelector(
  selectViewerInsights,
  viewerInsights => viewerInsights.viewers
);
export const selectActiveViewer = createSelector(
  selectViewerInsights,
  viewerInsights => viewerInsights.selectedView || null
);
